/**
 * ⚡ Serienmodus (Sonderfunktion „seriesMode", z. B. Green Goat)
 *
 * Ziel: pro Paket nur noch „Foto machen, Etikett aufkleben". Gemessen (09/2026) lagen zwischen
 * zwei Fotos 21 s, die KI braucht davon ~3 s — der Rest waren Tipps und Warten.
 *  - eingebaute Kamera öffnet von selbst (auch nach jedem gespeicherten Paket)
 *  - ist der Name erkannt und das Fach vorbelegt, wird nach kurzer Frist automatisch gespeichert
 *  - das Kamerabild ist klein (~1920 px) → schneller Upload
 * Pro Gerät abschaltbar; ohne Konto-Freischaltung immer aus.
 */
import { hasCustomFeature } from './customFeatures';

const KEY = 'kiosk_series_mode';
const FAIL_KEY = 'kiosk_series_cam_failed'; // sessionStorage: Kamera ging nicht → nicht erneut automatisch öffnen
export const AUTO_SAVE_SEKUNDEN = 2;

export function seriesAllowed() {
  return hasCustomFeature('seriesMode');
}

export function isSeriesOn() {
  if (!seriesAllowed()) return false;
  try { return localStorage.getItem(KEY) !== '0'; } catch { return true; }
}

export function setSeriesOn(on) {
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* */ }
}

export function seriesKameraFehlgeschlagen() {
  try { return sessionStorage.getItem(FAIL_KEY) === '1'; } catch { return false; }
}

export function merkeKameraFehler() {
  try { sessionStorage.setItem(FAIL_KEY, '1'); } catch { /* */ }
}

/**
 * Darf dieses Paket automatisch gespeichert werden? Nur im eindeutigen Normalfall:
 * neues Paket, Name erkannt (Kurzansicht), Fach vorbelegt, keine Retoure, kein Platzhaltername,
 * und der Nutzer hat nichts angefasst.
 */
export function darfAutoSpeichern({ seriesOn, paketId, quickConfirm, name, regalplatz, retoure, istPlatzhalter, angefasst, isSaving }) {
  if (!seriesOn || paketId || !quickConfirm || isSaving || angefasst) return false;
  if (!String(name || '').trim() || !String(regalplatz || '').trim()) return false;
  if (retoure || istPlatzhalter) return false;
  return true;
}
